import { render } from "./ChatGPTPage.vue?vue&type=template&id=ce9878ce"
import script from "./ChatGPTPage.vue?vue&type=script&lang=js"
export * from "./ChatGPTPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__